import { React, Component, Container } from "utils";
import { Creators, JobStore } from "model";
import { Filters, SearchFilter, Filter3 } from "components";

class JobSearch extends Component {
  static getStores() {
    return [JobStore];
  }

  static calculateState() {
    return {
      query: JobStore.getQuery(),
      loading: JobStore.isLoading(),
      filters: [
        { name: "categories", items: JobStore.getState().filters.categories },
        { name: "positions", items: JobStore.getState().filters.positions },
        { name: "locations", items: JobStore.getState().filters.locations },
        { name: "companies", items: JobStore.getState().filters.companies },
      ],
    };
  }

  handleChange = (event) => {
    let value = $(event.target).val();
    Creators.searchQueryChanged(value);
  };

  filterClick = (event) => {
    let filter = $(event.target).data("filter");
    let name = $(event.target).data("name");
    let index = $(event.target).data("index");
    Creators.jobsFilterItemClicked(filter, name, index);
  };

  removeFilterClick = (event) => {
    let filter = $(event.target).data("filter");
    let name = $(event.target).data("name");
    let index = $(event.target).data("index");
    Creators.jobsFilterItemRemoveClicked(filter, name, index);
  };

  applyFiltersClick = (event) => {
    Creators.jobsApplyFilters();
    let name = $(event.target).data("hide-function-name");
    Creators.closeFilterModal(name);

    Creators.jobsApplyFilters();
    Creators.hideFilterModal("jobs");
  };

  render() {
    const { query, loading, filters } = this.state;

    return (
      <div className="jobsearch">
        <Filter3
          filters={filters}
          page="jobs"
          query={query}
          loading={loading}
          handleChange={this.handleChange}
          onFilterClick={this.filterClick}
          onOkClick={this.applyFiltersClick}
          onTagClick={this.removeFilterClick}
        />
      </div>
    );
  }
}

export default Container.create(JobSearch);



// WEBPACK FOOTER //
// ./src/modules/components/jobsearch.js